import React from "react";
import moment from "moment";
import { Container, Row, Navbar, NavbarBrand } from "reactstrap";
import { ApplicationForm } from "@workspace/portfolio/src/components";
import { Images } from "@workspace/common";

export default function CandidateProfileBuilder() {
  return (
    <>
      <header>
        <Navbar className="p-2 bg-white">
          <NavbarBrand href="/">
            <img
              src={Images.avensys_full_logo}
              alt="avensys-logo"
              className="me-2"
              width="150"
            />
          </NavbarBrand>
        </Navbar>
      </header>
      <Container
        fluid
        className="d-flex flex-column px-5 pt-3 bg-light jobapp-container"
      >
        <Row className="mx-0 mt-3">
          <h3>Build Online CV</h3>
        </Row>
        <Row className="mx-2">
          <ApplicationForm />
        </Row>
      </Container>
      <footer className="d-flex pe-4 py-3 bg-light border-0">
        <span className="ms-auto">{moment().year()} © Avensys</span>
      </footer>
    </>
  );
}
